import { api } from "@/lib/axios";
import { Lead } from "@/types/lead";

type CreationData = {
  name: string;
  phone: string;
  email?: string;
  project: string;
  landSize: string;
  downPayment: string;
  monthlyPayment: string;
  appointmentDate?: string;
};

export default function createOne(data: CreationData) {
  return api.post("leads", {
    ...data,
    fullName: data.name,
    campaign: data.project,
    landMeasurement: data.landSize,
    mensuality: data.monthlyPayment,
    hitch: data.downPayment,
    source: "CRM",
  });
}
